
// import React, { useState } from "react";
// import { supabase } from "../lib/supabase";  // ✅ import supabase client
// import { toast } from "sonner";

// const ContactPage = () => {
//   const [form, setForm] = useState({ name: "", email: "", message: "" });
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) =>
//     setForm({ ...form, [e.target.name]: e.target.value });

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!form.name || !form.email || !form.message) {
//       return toast.error("Please fill in all fields.");
//     }

//     setLoading(true);

//     // ✅ Insert into Supabase
//     const { error } = await supabase.from("contact_messages").insert([
//       {
//         name: form.name,
//         email: form.email,
//         message: form.message,
//       },
//     ]);

//     setLoading(false);

//     if (error) {
//       console.error(error);
//       toast.error("Something went wrong. Please try again.");
//     } else {
//       toast.success("Message sent! We'll get back to you soon.");
//       setForm({ name: "", email: "", message: "" }); // reset form
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 py-16 px-6">
//       <div className="max-w-2xl mx-auto bg-white shadow-lg rounded-xl p-8">
//         <h1 className="text-4xl font-bold text-center mb-6">
//           Contact <span className="text-yellow-500">Us</span>
//         </h1>
//         <form onSubmit={handleSubmit} className="space-y-4">
//           <input
//             type="text"
//             name="name"
//             placeholder="Your Name"
//             value={form.name}
//             onChange={handleChange}
//             required
//             className="w-full border rounded-lg p-3 focus:ring-2 focus:ring-yellow-400 outline-none"
//           />
//           <input
//             type="email"
//             name="email"
//             placeholder="Your Email"
//             value={form.email}
//             onChange={handleChange}
//             required
//             className="w-full border rounded-lg p-3 focus:ring-2 focus:ring-yellow-400 outline-none"
//           />
//           <textarea
//             name="message"
//             placeholder="Your Message"
//             rows="5"
//             value={form.message}
//             onChange={handleChange}
//             required
//             className="w-full border rounded-lg p-3 focus:ring-2 focus:ring-yellow-400 outline-none"
//           />
//           <button
//             type="submit"
//             disabled={loading}
//             className="w-full bg-yellow-500 text-white font-semibold py-3 rounded-lg hover:bg-yellow-600 transition disabled:opacity-50"
//           >
//             {loading ? "Sending..." : "Send Message"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ContactPage;

// src/pages/ContactPage.js
import React, { useState } from "react";
import { supabase } from "../lib/supabase";
import { toast } from "sonner";
import Seo from "../components/seo/Seo";
import { trackGenerateLead } from "../lib/analytics";

const ContactPage = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [focused, setFocused] = useState("");

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in all fields.", {
        style: { background: '#1a1a1a', color: '#ef4444', border: '1px solid #374151' }
      });
      return;
    }

    setLoading(true);

    // Insert into Supabase
    const { error } = await supabase.from("contact_messages").insert([
      {
        name: form.name,
        email: form.email,
        message: form.message,
      },
    ]);

    setLoading(false);

    if (error) {
      console.error(error);
      toast.error("Something went wrong. Please try again.", {
        style: { background: '#1a1a1a', color: '#ef4444', border: '1px solid #374151' }
      });
    } else {
      toast.success("Message sent! We'll get back to you soon.", {
        style: { background: '#1a1a1a', color: '#fbbf24', border: '1px solid #374151' }
      });
      trackGenerateLead({ formName: "contact" });
      setForm({ name: "", email: "", message: "" });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black">
      <Seo
        title="Contact JmoLux"
        description="Contact JmoLux for skincare product questions, order support, shipping help and curated product recommendations."
        path="/contact"
      />
      <div className="container mx-auto px-4 py-6 sm:px-6 sm:py-10">
        <div className="mx-auto max-w-5xl">
          <div className="mx-auto mb-6 max-w-2xl text-center sm:mb-8">
            <p className="mb-2 text-[10px] font-semibold uppercase tracking-[0.28em] text-yellow-400/80">
              JmoLux Support
            </p>
            <h1 className="text-3xl font-light tracking-tight text-white sm:text-4xl md:text-5xl">
              Let's <span className="font-extralight italic text-yellow-400">Connect</span>
            </h1>
            <p className="mt-3 text-sm font-light leading-relaxed text-gray-400 sm:text-base">
              Questions about products, orders, or delivery? Send us a message.
            </p>
          </div>

          <div className="grid gap-4 lg:grid-cols-[minmax(0,1fr)_18rem] lg:gap-6">
            <div className="rounded-2xl border border-gray-800 bg-white/5 p-4 shadow-2xl backdrop-blur-sm sm:p-6">
              <div className="mb-5">
                <h2 className="text-lg font-light text-white sm:text-xl">Send a message</h2>
                <p className="mt-1 text-xs text-gray-500 sm:text-sm">
                  Complete the form and our support team will reply by email.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid gap-4 sm:grid-cols-2">
                  <div className="relative">
                    <label htmlFor="contact-name" className="mb-1.5 block text-[10px] font-semibold uppercase tracking-wider text-gray-400">
                      Name
                    </label>
                <input
                  id="contact-name"
                  type="text"
                  name="name"
                  placeholder="Your name"
                  value={form.name}
                  onChange={handleChange}
                  onFocus={() => setFocused("name")}
                  onBlur={() => setFocused("")}
                  required
                  className={`w-full bg-slate-950/40 border ${
                    focused === "name" ? "border-yellow-400" : "border-gray-700"
                  } rounded-xl px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:bg-white/5 transition-all duration-300`}
                />
                {focused === "name" && (
                  <div className="absolute inset-0 rounded-xl bg-yellow-400/5 pointer-events-none"></div>
                )}
                  </div>

                  <div className="relative">
                    <label htmlFor="contact-email" className="mb-1.5 block text-[10px] font-semibold uppercase tracking-wider text-gray-400">
                      Email
                    </label>
                <input
                  id="contact-email"
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={form.email}
                  onChange={handleChange}
                  onFocus={() => setFocused("email")}
                  onBlur={() => setFocused("")}
                  required
                  className={`w-full bg-slate-950/40 border ${
                    focused === "email" ? "border-yellow-400" : "border-gray-700"
                  } rounded-xl px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:bg-white/5 transition-all duration-300`}
                />
                {focused === "email" && (
                  <div className="absolute inset-0 rounded-xl bg-yellow-400/5 pointer-events-none"></div>
                )}
                  </div>
              </div>

              <div className="relative">
                <label htmlFor="contact-message" className="mb-1.5 block text-[10px] font-semibold uppercase tracking-wider text-gray-400">
                  How can we help?
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  placeholder="Tell us what you need help with..."
                  rows="5"
                  value={form.message}
                  onChange={handleChange}
                  onFocus={() => setFocused("message")}
                  onBlur={() => setFocused("")}
                  required
                  className={`w-full bg-slate-950/40 border ${
                    focused === "message" ? "border-yellow-400" : "border-gray-700"
                  } rounded-xl px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:bg-white/5 transition-all duration-300 resize-none`}
                />
                {focused === "message" && (
                  <div className="absolute inset-0 rounded-xl bg-yellow-400/5 pointer-events-none"></div>
                )}
              </div>

              <button
                type="submit"
                disabled={loading}
                className="group relative w-full rounded-xl bg-gradient-to-r from-yellow-500 to-yellow-600 px-6 py-3 text-sm font-semibold text-black transition-all duration-300 hover:from-yellow-400 hover:to-yellow-500 disabled:opacity-50 sm:w-auto sm:min-w-44"
              >
                {loading ? (
                  <div className="flex items-center justify-center">
                    <div className="w-4 h-4 border-2 border-black/30 border-t-black rounded-full animate-spin mr-2"></div>
                    Sending...
                  </div>
                ) : (
                  <div className="flex items-center justify-center">
                    Send Message
                    <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                    </svg>
                  </div>
                )}
              </button>
              </form>
            </div>

            <aside className="grid grid-cols-2 gap-3 lg:flex lg:flex-col">
              <a
                href="mailto:hello@jmolux.com"
                className="col-span-2 flex items-center rounded-2xl border border-gray-800 bg-white/5 p-4 transition-all hover:border-yellow-400/30 hover:bg-white/[0.08] lg:col-span-1"
              >
                <span className="mr-3 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-yellow-400/10">
                  <svg className="h-5 w-5 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </span>
                <span className="min-w-0">
                  <span className="block text-[10px] uppercase tracking-wider text-gray-500">Email us</span>
                  <span className="block truncate text-sm text-white">hello@jmolux.com</span>
                </span>
              </a>

              <div className="rounded-2xl border border-gray-800 bg-white/5 p-4">
                <svg className="mb-2 h-5 w-5 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="text-xs font-medium text-white">Quick response</p>
                <p className="mt-1 text-[10px] leading-relaxed text-gray-500 sm:text-xs">Usually within 24 hours</p>
              </div>

              <div className="rounded-2xl border border-gray-800 bg-white/5 p-4">
                <svg className="mb-2 h-5 w-5 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="text-xs font-medium text-white">Dedicated help</p>
                <p className="mt-1 text-[10px] leading-relaxed text-gray-500 sm:text-xs">Product and order support</p>
              </div>
            </aside>
            </div>
          </div>
        </div>
    </div>
  );
};

export default ContactPage;
